export default "__VITE_ASSET__BL9vsTdv__"